// ── Adapter Supabase do IPipelinesRepository ──────────────────────
// I/O puro contra `pipelines`/`funnels`.

import { getSupabase } from '@infra/supabase/client';
import type {
  IPipelinesRepository,
  PipelineIdsParams,
  FunnelSummary,
  PipelineRich,
} from '@modules/config';

const client = () => {
  const s = getSupabase();
  if (!s) throw new Error('Supabase não inicializado.');
  return s;
};

export class SupabasePipelinesRepository implements IPipelinesRepository {
  listPipelineIds = async (params: PipelineIdsParams): Promise<string[]> => {
    const { workspaceId, funnelId = null, role = null } = params;
    let q = client()
      .from('pipelines')
      .select('id')
      .eq('workspace_id', workspaceId)
      .eq('ativo', true);
    if (funnelId) q = q.eq('funnel_id', funnelId);
    if (role) q = q.eq('role', role);
    const { data, error } = await q;
    if (error) throw error;
    return (data || []).map((p) => p.id);
  };

  listFunnels = async (workspaceId: string): Promise<FunnelSummary[]> => {
    const { data, error } = await client()
      .from('funnels')
      .select('id, name')
      .eq('workspace_id', workspaceId)
      .eq('ativo', true)
      .order('name');
    if (error) throw error;
    return data || [];
  };

  listPipelinesRich = async (workspaceId: string): Promise<PipelineRich[]> => {
    const { data, error } = await client()
      .from('pipelines')
      .select('id, name, role, color, ativo, funnel:funnels ( id, name ), pipeline_stages ( id, name, order_index, ativo )')
      .eq('workspace_id', workspaceId)
      .eq('ativo', true)
      .order('role', { ascending: true });
    if (error) throw error;
    return (data || []) as unknown as PipelineRich[];
  };
}
